import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { AboutMenuComponent } from '../../shared/about-menu/about-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';

@Component({
  selector: 'app-college',
  standalone: true,
  imports: [CommonModule, MainMenuComponent, AboutMenuComponent, SubscribeComponent],
  templateUrl: '../templates/college.component.html'
})
export class CollegeComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
        // Ensure sticky menu is properly initialized
        setTimeout(() => {
          this.initializeStickyMenu();
          window.dispatchEvent(new Event('scroll'));
        }, 150);
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  private initializeStickyMenu(): void {
    const $ = (window as any).jQuery;
    if ($ && typeof $ === 'function') {
      const header = $('.menu-sticky');
      const scroll = $(window).scrollTop() || 0;
      if (scroll > 0) {
        header.addClass('sticky');
      } else {
        header.removeClass('sticky');
      }
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }
}

